import { SettingsType } from "adviesbox-shared";
import { User } from "oidc-client";
import { hasJSONResponse } from "../../shared/utils/ajax";
import { ReplaceableTagInfo } from "../../.generated/rapportage/rapportagetypes";

let cachedTags: ReplaceableTagInfo[] | null = null;

/**
 * Fetches the available tags from the rapportage API.
 * @param settings - Application settings containing the rapportageOrigin
 * @param user - Authenticated user for authorization
 * @returns Promise resolving to an array of ReplaceableTagInfo objects
 */
export const getRapportageTags = async (
  settings: SettingsType,
  user: User | null
): Promise<ReplaceableTagInfo[]> => {
  // Return cached tags if available
  if (cachedTags !== null) {
    return cachedTags;
  }

  const url = `${settings.rapportageOrigin}/Rapportage/Tags`;
  const rsp = await fetch(url, {
    method: "GET",
    headers: {
      authorization: `${user?.token_type} ${user?.access_token}`,
      "Content-Type": "application/json;charset=UTF-8",
      "Ocp-Apim-Subscription-Key": settings.OcpApimSubscriptionKey
    }
  });

  try {
    if (!(rsp.ok && hasJSONResponse(rsp))) {
      const error = new Error(`Fout bij aanroep van web-api '${url}'. Resultaat bevat geen JSON.`);
      error.name = "GeenJSONError";
      throw error;
    }

    const json: ReplaceableTagInfo[] = await rsp.json();

    // Cache the result
    cachedTags = json;

    return json;
  } catch (error) {
    const err = error as Error;
    // Handle JSON parsing errors (SyntaxError in browsers, FetchError in node-fetch)
    if (err?.name === "SyntaxError" || err.name === "GeenJSONError" || err.name === "FetchError") {
      return [];
    }
    throw error;
  }
};

/**
 * Clears the memoized tags cache.
 * Useful for testing or forcing a refresh of tags.
 */
export const clearTagsCache = (): void => {
  cachedTags = null;
};

